import { RuleSearchPage } from "./RuleSearchPage";
export default RuleSearchPage;
